export function addCharsEveryK(
  input: string,
  chars: string,
  k: number,
  includeLast: boolean = false,
): string {
  let output = '';
  for (let i = 0; i < input.length; i += k) {
    output += input.substr(i, k);
    if (i + k <= (includeLast ? input.length : input.length - 1)) {
      output += chars;
    }
  }
  return output;
}
